// require('axios');
let csrf = $('meta[name="csrf-token"]').attr('content');
let token = $('meta[name="api"]').attr('content');
let bear = {
    headers: { Authorization: `Bearer ${token}` }
};

$('#ConfirmDelete').on('show.bs.modal', function(e) {
    $nome = $(e.relatedTarget).parent().parent().find('td').eq(1).text();
    var id = $(e.relatedTarget).attr('data-id');
    var message = "Realmente deseja Apagar o Registro de <b>"+ $nome+"</b> cod# "+ id +" ?";
    var act = $(e.relatedTarget).attr('href');
    var form = '<form name="form" method="post" action="'+act+'"> ' +
        '<input type="hidden" name="_method" value="DELETE">'
        + '<input name="_token" type="hidden" value="'+csrf+'">'
        + '<button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal"><i class="fa fa-times me-2"></i> Cancelar</button>'
        + '<button class="btn btn-danger"><i class="fa fa-exclamation-triangle"></i> Confirma</button>'
        + '</form>';
    $(this).find('.modal-body p').html(message);
    $(this).find('.modal-footer').html(form);
});

// Disable button on submit
$(document).ready(function () {
    $('form').submit(function() {
        var el = $(this);
        el.find("button[type='submit'],input[type='submit']").prop('disabled',true);
        $('select').removeAttr('disabled');
        setTimeout(function(){el.prop('disabled', false); }, 7000);
    });
});

// modal
$("body").on('click','.loadModal,.bigModal,.fullModal',function(ev) {
    ev.preventDefault();
    if($(this).hasClass("bigModal")){
        $("#myModal .modal-dialog").addClass('modal-lg');
    }if($(this).hasClass("fullModal")){
        $("#myModal .modal-dialog").addClass('modal-xl');
    }
    var target = $(this).attr("href");
    $("#myModal .modal-content").load(target, function() {

        var myModal = new bootstrap.Modal(document.getElementById('myModal'), {
            backdrop: 'static',
            keyboard: false
        });

        myModal.show();

        $(".dataModal").flatpickr({
            "locale": "pt",
            'dateFormat': "d/m/Y",
            'allowInput' : true,
        });
        $('.selectizeModal').select2({
            placeholder: "Selecione uma opção",
            selectOnClose: true
        });
    });

    $('body').on('change','#conta', function () {
        montarOptions(this.value, $('#real'));
    })
});

function montarOptions(conta, select) {
    select.empty();
    let json = $('#formas').val();
    select.prop( "disabled", false);
    if (conta !== "") {
        json = JSON.parse(json);
        Object.entries(json[conta]).forEach((entry) => {
            const [key, value] = entry;
            let option = JSON.stringify(value);
            option = JSON.parse(option);
            for (const k in option) {
                let newOption = new Option(option[k], k, false, false);
                select.append(newOption);
            }
            select.trigger('change');
        });
    } else {
        select.prop( "disabled", true);
    }
}

$('body').on('hidden.bs.modal', '.modal', function () {
    $(this).removeData('bs.modal');
}).on('shown.bs.modal', '.modal', function () {
    $('#focusModal').focus();
}).on('click','.printPage',function (e) {
    e.preventDefault();
    $(this).printPage({
        message:"Seu documento está sendo impresso",
    });
    $(this).click();
});

var maskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    options = {onKeyPress: function(val, e, field, options) {
            field.mask(maskBehavior.apply({}, arguments), options);
        }
    };

$(".cep").mask("99.999-999");
$(".cnpj").mask("99.999.999/9999-99");
$(".cpf").mask("999.999.999-99");
$('.hora').mask('99:99');

$('.dataModal').mask('99/99/9999');
$('.anoModelo').mask('9999/9999');
$('.dataHora').mask('99/99/9999 99:99');
$('.monetary').maskMoney();
$(".money").maskMoney({prefix:'R$ ', allowNegative: true, thousands:'.', decimal:',', affixesStay: false});
$(".peso").maskMoney({prefix:'', allowNegative: false, thousands:'.', decimal:',', affixesStay: false, precision: 3});
$('.tel').mask(maskBehavior, options);

$('body').on('focus', '.data', function(){
    $(this).mask("99/99/9999");
});

$('body').on('focus', '.tel', function(){
    $(this).mask(maskBehavior, options);
});

$('body').on('focus', '.money', function(){
    $(this).maskMoney({prefix:'R$ ', allowNegative: true, thousands:'.', decimal:',', affixesStay: false});
});

var CpfCnpjMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length <= 11 ? '000.000.000-009' : '00.000.000/0000-00';
    },
    cpfCnpjpOptions = {
        onKeyPress: function(val, e, field, options) {
            field.mask(CpfCnpjMaskBehavior.apply({}, arguments), options);
        }
    };

$('.cpfcnpj').mask(CpfCnpjMaskBehavior, cpfCnpjpOptions);

$("#checkAll").click(function(){
    $('input:checkbox').not(this).prop('checked', this.checked);
});

$(document).ready(function () {
    function matchCustom(params, data) {

        // If there are no search terms, return all of the data
        if ($.trim(params.term) === '') {
            return data;
        }
        // Do not display the item if there is no 'text' property
        if (typeof data.text === 'undefined') {
            return null;
        }

        const terms = params.term.toUpperCase().split(' ');
        var text = data.text.toUpperCase();
        var ok = true;
        var res = terms.every(term => {
            if (text.indexOf(term) > -1 && ok == true) {
                return true;
            } else{
                ok = false;
                return false;
            }
        });

        if(res){
            return $.extend({}, data, true)
        }

        return null;

    }

    $('.selectize').select2({
        placeholder: "Selecione uma opção",
        selectOnClose: true,
        matcher: matchCustom,
        //width : '350px',
    });

    $('#flash-overlay-modal').modal();
});

$('#city').select2(optionsSelect2('cidades'));

function optionsSelect2(type)
{
    return {
        minimumInputLength: 2,
        placeholder: "Buscar",
        ajax: {
            url: '/api/'+type,
            dataType: 'json',
            headers: {"Authorization": 'Bearer '+token},
            type: "GET",
            quietMillis: 50,
            data: function (params) {
                var queryParameters = {
                    q: params.term
                };
                return queryParameters;
            },
        },
    }
}

$(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
    $(this).closest(".select2-container").siblings('select:enabled').select2('open');
});

$(document).on('select2:open', () => {
    document.querySelector('.select2-search__field').focus();
});

// steal focus during close - only capture once and stop propogation
$('select.select2').on('select2:closing', function (e) {
    $(e.target).data("select2").$selection.one('focus focusin', function (e) {
        e.stopPropagation();
    });
});

function dinheiro(v)
{
    return v.toLocaleString( 'pt-Br',{style: 'currency', currency: 'BRL'});
}

$(".data").flatpickr({
    "locale": "pt",
    'allowInput' : true,
    'dateFormat': "d/m/Y",
});

$(".dataHora").flatpickr({
    "locale": "pt",
    'allowInput' : true,
    'dateFormat': "d/m/Y",
});

$(document).on('blur','.cep',function() {
     let cep = $(this).val().replace(/\D/g, '');
    let validacep = /^[0-9]{8}$/;
     if(cep != '' && validacep.test(cep)){
         loadingCep();
         axios.get(`//viacep.com.br/ws/${cep}/json`)
             .then(response => {
                 setdadosCep(response.data);
             })
             .catch(error => {
                 console.log(error)
             })
     }
});

function loadingCep()
{
    $("#logradouro").val("...");
    $("#bairro").val("...");
    $("#cidade").val('...');
    $("#uf").val('');
}

function setdadosCep(dados) {
    $("#logradouro").val(dados.logradouro);
    $("#bairro").val(dados.bairro);
    $("#cidade").val(dados.localidade);
    $("#uf").val(dados.uf);

    var newOption = new Option(dados.localidade + ' - ' + dados.uf, dados.ibge, true, true);
    $('#city').append(newOption).trigger('change');
}
$('#cpf_cnpj').on('change',function (){
    let val = $(this).val();
    if(val.length == 18){
        resetDadosCnpj();
        let cnpj = val.replace(/\D/g, '');
        axios.get(`/api/consulta-cnpj/${cnpj}`)
            .then(response => {
                setDadosCnpj(response.data);
            })
            .catch(error => {
                console.log(error)
            })
    }
});

function resetDadosCnpj()
{
    $('#nome').val('...');
    $('#cep').val('');
    $('#logradouro').val('...');
    $('#complemento').val('...');
    $('#bairro').val('...');
    $('#uf').val('');
}

function setDadosCnpj(data)
{
    $('#nome').val(data.nome);
    $('#nome_fantasia').val(data.fantasia);
    $('#cep').val(data.cep);
    $('#cep').blur();
    $('#tipo').val(1);
    $('#logradouro').val(data.logradouro);
    $('#complemento').val(data.complemento);
    $('#numero').val(data.numero);
    $('#bairro').val(data.bairro);
    $('#uf').val(data.uf);
    $('#email').val(data.email);
    $('#telefone1').val(data.telefone);
}

const observer = new MutationObserver(function() {
    if ($('.alert').length > 0) {
        let target = $(".navbar-nav");
        smoothScroll(target, 500);
    }
});

function smoothScroll(target, duration) {
    let targetPosition = target.offset().top;
    let startPosition = $(window).scrollTop();
    let distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        let timeElapsed = currentTime - startTime;
        let run = ease(timeElapsed, startPosition, distance, duration);

        $(window).scrollTop(run);

        if(timeElapsed < duration) window.requestAnimationFrame(animation);
    }

    // you can change 'ease' to other easing functions
    function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }

    window.requestAnimationFrame(animation);
}

observer.observe(document.body, { childList: true, subtree: true });
